// A dependency-free vertical bar chart for a numeric series (e.g. daily spend).
// The final bar is emphasised to echo the "current period" look of AWS cost
// widgets; the rest are drawn in a translucent tint of the same color.
export default function MiniBars({ data = [], height = 132, color = 'var(--accent)' }) {
  if (!data.length) return <div className="trend trend--empty">No data</div>;
  const max = Math.max(...data, 1);
  return (
    <div className="minibars" style={{ height }}>
      {data.map((v, i) => {
        const last = i === data.length - 1;
        return (
          <div
            key={i}
            className="minibars__bar"
            title={String(v)}
            style={{
              height: `${Math.max((v / max) * 100, 1)}%`,
              background: last
                ? color
                : `color-mix(in srgb, ${color} 40%, transparent)`,
            }}
          />
        );
      })}
    </div>
  );
}
